<template>
  <div class="d-flex">
    <Grid @edit="edit"
      :style="{ height: 'auto', width: '100%' }"
      :data-items="dataItem.configDBDetail"
      :columns="columns"
      :resizable="true"
    ></Grid>
  </div>
</template>

<script>
import { Grid } from "@progress/kendo-vue-grid";
import CommandCell from "@/components/CommandCellTemplate/CommandCellEditTemplate";
export default {
  props: {
    dataItem: Object,
    columnIndex: Number,
  },
  components: {
    Grid: Grid,
  },
  data: function() {
    return {
      columns: [
        { field: "microserviceName", width: "100px", filterable: false, editable: false, title: "MICROSERVICE NAME"},
        { field: "connectionString", width: "250px", filterable: false, editable: false, title: "CONNECTION STRING" },
        { hidden: false, cell: CommandCell, width: '50px', locked: true, title: "Actions",  ignoreCheckbox: true },
      ]
    }
  },
  methods: {
    edit: function(item) {
      return this.$store.dispatch("configuration/editDBDetail", item.dataItem); //item.dataItem.id
    },
  }
}
</script>

<style lang="scss" scoped>
.k-grid-header .k-header > .k-link {
  padding: 0.4rem 0.4rem;
}
.additional {
  border-style: solid;
  border: 1px solid #d0d0d0;
  background-color: #ffffff;
  padding: 10px;
  color: #585857;
  p {
    margin-top: 0;
    margin-bottom: 5px;
  }
}
</style>